// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class SubscriptionAPI extends MainAPI {
	/**
	 * @param {*} userDetails - Contains user details for email subscription
	 */
	async subscribeEmail(userDetails) {
		return API.post(ENDPOINTS.POST_SUBSCRIPTION_EMAIL, userDetails);
	}
	
	/**
	 * @return {*} frequency and subscription list
	 */
	async getSubscriptionPeriod() {
		return API.get(ENDPOINTS.GET_SUBSCRIPTION_PERIOD);
	}

	/**
	 * @return {object} tracking subscription
	 * @param {petId}
	 */
	async getSubscriptionTrack(petId) {
		return API.get(`${ENDPOINTS.GET_SUBSCRIPTION_TRACK}/${petId}`);
	}

	/**
	 * Retrieves subscription details for a given subscription ID.
	 * @async
	 * @param {string} subscriptionId - The ID of the subscription to retrieve details for.
	 * @returns {Promise<object>} A Promise that resolves to an object representing the subscription details.
	 */
	async getSubscriptionDetails(petId, subscriptionId) {
		return API.get(`${ENDPOINTS.GET_SUBSCRIPTION_DETAILS}/${petId}/${subscriptionId}`);
	}

	/**
	 * Requests cancellation of a subscription for a specific pet.
	 *
	 * @async
	 * @function requestSubscriptionCancellation
	 * @param {string|number} petId - The ID of the pet associated with the subscription to cancel.
	 * @param {string|number} subscriptionId - The ID of the subscription to cancel.
	 * @param {Object} subscriptionDetails - Additional details for the cancellation request.
	 * @param {string|number} subscriptionDetails.orderId - The ID of the order associated with the subscription.
	 * @param {string} subscriptionDetails.remarks - Any remarks associated with the cancellation request.
	 * @returns {Promise<Object>} A promise that resolves with the result of the cancellation request.
	 * @throws {Error} If an error occurs during the cancellation request.
	*/
	async requestSubscriptionCancellation(petId, subscriptionId, subscriptionDetails) {
		return API.put(`${ENDPOINTS.PUT_SUBSCRIPTION}/${petId}/${subscriptionId}/request-cancellation`, subscriptionDetails);
	}
}

export default new SubscriptionAPI();
